const UserType = {
  ROLE: 'user/roles',
  LOGIN: 'user/login',
  LOG_OUT: 'user/log_out',
};

export default UserType;
